// Small, dynamic HTML fragments for the clip-builder video-source popovers.
//
// These are the *dynamic* bits (AJAX render lists, the two-option model
// picker, the inline "Sure?" confirm, library thumbnails) that cannot be
// server-rendered up front because their content depends on a fetch. The large
// *static* overlay forms live in server-rendered ViewComponents
// (app/components/clip_builder/overlay_forms_component). Kept here as pure
// string builders so they are isolated from the controllers and unit-tested.

export function renderPickerListMarkup(renders) {
  if (!renders || renders.length === 0) {
    return '<div class="p-3 text-sm text-gray-500">No completed renders found</div>'
  }

  return renders
    .map(
      (r) => `
          <button type="button"
                  class="w-full text-left px-3 py-2 text-sm hover:bg-indigo-50 transition-colors border-b border-gray-100 last:border-0"
                  data-action="click->clip-video-source#selectRender"
                  data-render-id="${r.id}">
            <span class="font-medium text-gray-800">${r.name}</span>
            <span class="text-gray-400 ml-2">${r.created_at}</span>
            ${r.duration ? `<span class="text-gray-400 ml-1">(${r.duration}s)</span>` : ""}
          </button>
        `,
    )
    .join("")
}

export function renderPickerErrorMarkup() {
  return '<div class="p-3 text-sm text-red-500">Failed to load renders</div>'
}

export function modelPickerMarkup() {
  return `
      <p class="text-xs font-medium text-gray-500 px-2 pb-1">Video model</p>
      <button data-model="veo_3_1_fast" class="w-full text-left px-3 py-1.5 text-xs rounded hover:bg-indigo-50 transition-colors">
        <span class="font-medium text-gray-800">Fast</span>
        <span class="text-gray-400">— ~$0.15/s</span>
      </button>
      <button data-model="veo_3_1" class="w-full text-left px-3 py-1.5 text-xs rounded hover:bg-indigo-50 transition-colors">
        <span class="font-medium text-gray-800">Quality</span>
        <span class="text-gray-400">— ~$0.40/s</span>
      </button>
    `
}

export function removeVideoConfirmMarkup() {
  return `
      <span class="text-xs text-red-600">Sure?</span>
      <button data-yes class="text-xs font-medium text-red-600 hover:text-red-800 underline">Yes</button>
      <button data-no class="text-xs text-gray-400 hover:text-gray-600">No</button>
    `
}

export function libraryEmptyMarkup() {
  return '<p class="text-xs text-gray-400 py-2">No images in library. <a href="/media/new" target="_blank" class="text-amber-600 hover:underline">Upload one</a></p>'
}

export function libraryErrorMarkup() {
  return '<p class="text-xs text-red-400 py-2">Failed to load library</p>'
}

export function libraryThumbInnerMarkup(asset) {
  return `<img src="${asset.url}" alt="${asset.name}" class="w-full h-full object-contain" /><span class="absolute inset-x-0 bottom-0 text-[9px] text-white bg-black/60 px-1 truncate">${asset.name}</span>`
}
